import React from 'react';
import { Badge } from './ui/badge';

/**
 * Calculate experience level based on years of experience
 * 0-2 years = Junior
 * 3-5 years = Confirmé
 * 6+ years = Sénior
 */
export const getExperienceLevel = (yearsOfExperience) => {
  const years = parseInt(yearsOfExperience) || 0;
  
  if (years <= 2) {
    return {
      level: 'Junior',
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      years: years
    };
  } else if (years <= 5) {
    return {
      level: 'Confirmé',
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      years: years
    };
  } else {
    return {
      level: 'Sénior',
      color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      years: years
    };
  }
};

/**
 * Experience Level Badge Component
 * Displays a styled badge with the talent's experience level
 */
export const ExperienceLevelBadge = ({ yearsOfExperience, showYears = false, size = 'default' }) => {
  const { level, color, years } = getExperienceLevel(yearsOfExperience);
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    default: 'text-sm px-2.5 py-0.5',
    lg: 'text-sm px-3 py-1'
  };
  
  return (
    <Badge 
      className={`${color} border font-medium ${sizeClasses[size]}`}
      data-testid="experience-level-badge"
    >
      {level}
      {showYears && (
        <span className="ml-1 opacity-75">
          ({years} an{years > 1 ? 's' : ''})
        </span>
      )}
    </Badge>
  );
};

export default ExperienceLevelBadge;
